;(function () {

"use strict";

var Instafeed = require('instafeed.js');

// var token = "2940014190.2173d40.13aa6292351244f4a763dacc0e8e72cf";

var InstagramView = Backbone.View.extend({
  initialize: function () {
    // var feed = new Instafeed({
    //   accessToken: "IGQVJVdWFQZA2hUTzh0LThBcG82eG00WmFfSUlwZAFVGLVlPZAUphRTZANNWJibHRWVmp5TFVNcHFtcGhkM3JldTRYNXFWZAjBIUGZAmWHdnUzM2WS00UGU0aG1NS1M0Qy1pWmhhQndxUmhBTURXR1lMVFJkRQZDZD",
    //   target: this.$el.find('ul')[0],
    //   limit: 5,
    //   template: '<li><a target="_blank" href="{{link}}"><img title="{{caption}}" alt="{{caption}}" src="{{image}}"/></a></li>&nbsp;'
    // });

    // feed.run();

    var $el = this.$el.find('ul');
    $.get('https://cdn.roseandrex.com/instagram-feed.json').then(function (data) {

      var json = JSON.parse(data);
      var feed = json.data.slice(0, 5);
      var html = '';

      _.forEach(feed, function (post) {
        var image = post.thumbnail_url || post.media_url;
        var caption = post.caption;
        var link = post.permalink;

        html += '<li><a target="_blank" href="'+link+'"><img title="'+caption+'" alt="'+caption+'" src="'+image+'"/></a></li>&nbsp;';
      });

      $el.html(html);
    });
  }
});

module.exports = InstagramView;

}());